<template>
  <section>
    <el-button-group>
      <el-button
        size="small"
        type="primary"
        @click.native="openSearchMain()"
      >{{value==null?$t('choose'): field(butName)}}</el-button>
      <el-button
        v-if="value!=null"
        size="small"
        type="primary"
        icon="el-icon-delete"
        @click.native="deleteitem()"
      ></el-button>
    </el-button-group>
    <el-dialog
      :title="$t('SearchProduct')"
      :visible.sync="ProductVisible"
      v-model="ProductVisible"
      width="80%"
      custom-class="minheight"
      append-to-body
    >
      <el-col :span="24" class="toolbar comptoolbar" style="padding-bottom: 0px;">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item>
            <el-input v-model="searchVal" :placeholder="$t('pleaseEnter')+'...'" size="small"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="callFunc()" size="small">{{$t('search')}}</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <!--列表-->
      <el-table
        ref="listTable"
        :data="list"
        highlight-current-row
        v-loading="listLoading"
        style="width: 100%; min-height:300px;"
        @cell-dblclick="dblhandleCurrentChange"
      >
        <el-table-column :label="$t('Cover')" width="120">
          <template slot-scope="scope">
            <div
              v-if="scope.row.Cover!=null&&scope.row.Cover!=''"
              class="coverimg"
              :style="{backgroundImage: 'url(' + baseCoverUrl + scope.row.Cover + ')'}"
            ></div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('Name')">
          <template slot-scope="scope">{{field(scope.row.Name)}}</template>
        </el-table-column>
        <el-table-column :label="$t('TypeName')">
          <template slot-scope="scope">{{field(scope.row.ProductType.Name)}}</template>
        </el-table-column>
        <el-table-column :label="$t('LowestNumber')" width="80" prop="LowestNumber"></el-table-column>
        <el-table-column :label="$t('Price')" width="100" prop="Price">
          <template slot-scope="scope">
            <span class="text_red">$ {{scope.row.Price}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="Reco" :label="$t('Reco')" width="70">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.Reco  ? 'success' : 'danger'"
              disable-transitions
            >{{scope.row.Reco ? $t('yes'):$t('no')}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="Hot" :label="$t('Hot')" width="70">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.Hot  ? 'success' : 'danger'"
              disable-transitions
            >{{scope.row.Hot ? $t('yes'):$t('no')}}</el-tag>
          </template>
        </el-table-column>
      </el-table>

      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination
          layout="total, prev, pager, next"
          @current-change="handleCurrentChange"
          :page-size="20"
          :total="total"
          style="float:right;"
        ></el-pagination>
      </el-col>

      <div slot="footer" class="dialog-footer"></div>
    </el-dialog>
  </section>
</template>
<script>
import util from "util/date";
import {  base,searchProduct } from "@/api/api";
export default {
  name: "SearchProduct",
  data() {
    return {
      baseCoverUrl: base+ "/FileUpload/Product/b0/",
      ProductVisible: false,
      searchVal: "",
      selectType: 0,
      list: [],
      total: 0,
      page: 1,
      listLoading: false,
      butName: this.text,
    };
  },
  props: {
    shopId: "",
    value: Number,
    text: {},
    SpecTypeList: null,
    Product: null,
  },
  methods: {
    formatDate: function (val) {
      return util.formatDate.format(new Date(val), "yyyy-MM-dd hh:mm");
    },
    clickType(val, name) {
      this.selectType = val;
      this.selectTypeName = name;
    },
    callFunc(item) {
      this.getList();
    },
    openSearchMain() {
      this.ProductVisible = true;
      this.getList();
    },
    dblhandleCurrentChange(row, column, cell, event) {
      this.butName = row.Name;
      this.$emit("input", row.Id);
      this.$emit("text", this.butName);
      this.$emit("Product", row);
      this.$emit("SpecTypeList", row.SpecTypeList);
      this.$emit("change", row);
      console.log(111);
      this.ProductVisible = false;
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    deleteitem() {
      this.butName = null;
      this.isdel = true;
      this.$emit("input", null);
      this.$emit("text", null);
    },
    getList() {
      let para = {
        page: this.page,
        key: this.searchVal,
        type: this.selectType,
        shopId: this.shopId,
      };
      this.list = [];
      searchProduct(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.list = res.data.response.data;
        this.listLoading = false;
      });
    },
  },
  watch: {
    text() {
      this.butName = this.text;
    },
  },
  mounted() {},
};
</script>